
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/dinesh_ai",
      function () {
        return require("private-next-pages/[id]/dinesh_ai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/dinesh_ai"])
      });
    }
  